<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content" data-testid="certificate-page">
	<div class="content-wrapper">
		<div class="content-detached">
			<div class="content-body">
				<app-search-bar [criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal" [config]="configLocal.barraBusqueda" [useAccordionMode]="true" [registroActivacion]="false" [mostrarListaCompletaEmisores]="true" [listaCompletaEmisores]="emisoresSource" [filtroEmisor]="true" [filtroSucursal]="false" [useInlineSearchButton]="true" [useInlineDeactivatedCheckbox]="false" (busqueda)="searchElementsByFilter($event)" [emisorClearable]="false" [sucursalClearable]="false"> </app-search-bar>
				<div class="row">
					<div class="col-12">
						<div class="card card-custom">
							<div class="card-header">
								<h4 class="card-title">Certificados Digitales</h4>
							</div>
							<div class="card-head">
								<div class="heading-elements mt-0" *ngIf="permissions.getPermission('20-20-10').asignado">
									<button data-testid="certificate-upload-open" class="btn btn-success float-right mr-5 mt-5" (click)="openCreateCertificateModal(createCertificateModal)">
										<i class="flaticon-add-circular-button"></i>
										Cargar
									</button>
								</div>
								<div class="heading-elements mt-0">
									<button data-testid="certificate-purchase-open" *ngIf="compraCertificadoWizard" class="btn btn-primary float-right mr-5 mt-5" (click)="openCertificateDigitalModal(false, null)">
										<i class="fa-solid fa-file-certificate"></i>
										Generar Certificado
									</button>
									<button data-testid="certificate-purchase-open" *ngIf="!compraCertificadoWizard" class="btn btn-primary float-right mr-5 mt-5" (click)="openCertificateDigitalModal(false, null)">
										<fa-icon icon="shopping-cart" class="fa-lg"></fa-icon>
										Comprar Certificado
									</button>
								</div>
							</div>
							<div class="card-content">
								<div class="card-body">
									<ngx-datatable
										#table
										class="material mobile-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="70"
										fxFlex="auto"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										(sort)="utilities.onSortTable(table, page)"
										[messages]="{
											emptyMessage: 'Sin datos para mostrar' | translate,
											totalMessage: 'Elementos totales' | translate,
											selectedMessage: false
										}"
										[externalSorting]="false"
										[sortType]="SortType.multi">
										<ngx-datatable-column name="friendlyName" [flexGrow]="5" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Nombre</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment" [attr.data-testid]="'certificate-name-' + row.certificadoDigitalId">{{ row.nombre }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="rutString" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Rut</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment" [attr.data-testid]="'certificate-rut-' + row.certificadoDigitalId">{{ row.rutFormateado }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="estado" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Estado</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment text-nowrap" [attr.data-testid]="'certificate-status-' + row.certificadoDigitalId">{{ row.estadoNombre }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="fechaSubida" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'date-table-alignment'" [headerClass]="'date-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Carga</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment" [attr.data-testid]="'certificate-uploaded-' + row.certificadoDigitalId">{{ row.fechaSubida | date : "dd/MM/yyyy" }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="fechaVenc" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'date-table-alignment'" [headerClass]="'date-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Vencimiento</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment" [attr.data-testid]="'certificate-expires-' + row.certificadoDigitalId">{{ row.fechaVenc | date : "dd/MM/yyyy" }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="mesesRestantes" [flexGrow]="2" [sortable]="true" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Meses Restantes</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.mesesRestantes }} Meses</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="Acciones" [flexGrow]="4" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<a *ngIf="permissions.getPermission('20-20-16').asignado && (row.garantia || row.origenCertificadoId == 4)" class="primary edit mr-1 mrless" ngbTooltip="Descargar Certificado" (click)="CertificateDownloadRequest(row)">
													<div class="icon-circle bg-warning text-center align-middle pt-file-button">
														<fa-icon icon="file-code" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<!--Reposicion-->
												<a *ngIf="permissions.getPermission('20-20-16').asignado && !row.garantia && row.origenCertificadoId != 4" class="primary edit mr-1 mrless" ngbTooltip="Descargar Certificado" (click)="CertificateDownloadRequest(row)">
													<div class="icon-circle bg-warning text-center align-middle pt-file-button">
														<fa-icon icon="file-code" class="fa-lg text-white"></fa-icon>
													</div>
												</a>											
												<a
													*ngIf="permissions.getPermission('20-20-12').asignado"
													class="primary edit mr-1 mrless"
													ngbTooltip="Eliminar Certificado"
													[swal]="{
														title: 'Eliminar certificado',
														html: 'Si elimina este certificado, ya no podrá volver a descargarlo desde SimpleFactura.<br><br>Si el certificado tiene garantía, descárguelo y guárdelo primero en su equipo para no perderlo.<br><br>Se recomienda guardar siempre una copia local antes de eliminar.<br><br>¿Desea continuar?',
														confirmButtonText: 'Sí, eliminar',
														cancelButtonText: 'Cancelar',
														showCancelButton: true,
														confirmButtonColor: '#F64E60'
													}"
													(confirm)="deleteCertificate(row)">
													<div class="icon-circle bg-danger text-center align-middle pt-info-button">
														<fa-icon icon="trash" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a *ngIf="shouldShowRenewButton(row)" class="primary edit mr-1 mrless" ngbTooltip="Renovar Certificado" (click)="openCertificateDigitalModal(true, row)">
													<div class="icon-circle bg-primary text-center align-middle pt-info-button">
														<fa-icon icon="sync-alt" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a *ngIf="permissions.getPermission('20-20-20').asignado && row.estadoId == 1 && !row.revocacionPendiente && row.origenCertificadoId != 4"
													class="primary edit mr-1 mrless"
													ngbTooltip="Solicitar Revocación"
													(click)="openRevokeModal(revokeCertificateModalRef, row)">
													<div class="icon-circle bg-danger text-center align-middle pt-info-button">
														<fa-icon icon="ban" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<span *ngIf="row.revocacionPendiente" class="badge badge-warning">Revocación en curso</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="col-auto">Elementos por página</div>
												<div class="mr-5">
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-5 col-auto divisor-footer">
													<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos totales</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="table.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>

									<!-- seccion tabla mobile-->
									<ngx-datatable
										#tableMobile
										*ngIf="componentStarted"
										class="material desktop-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="85"
										fxFlex="auto"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										[scrollbarH]="true"
										[messages]="{
											emptyMessage: 'Sin datos para mostrar' | translate,
											totalMessage: 'Elementos totales' | translate,
											selectedMessage: false
										}">
										<!-- Row Detail Template -->
										<ngx-datatable-row-detail [rowHeight]="70" #myDetailRow>
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
												<div class="text-wrap">
													Nombre: {{ row.friendlyName }} , Rut: {{ row.rutString }}, Meses Restantes:
													{{ row.mesesRestantes }}
												</div>
											</ng-template>
										</ngx-datatable-row-detail>
										<ngx-datatable-column [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
												<a [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="Expand/Collapse Row" (click)="toggleExpandRow(row)" class="desktop-hidden"> </a>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="carga" [flexGrow]="4" [sortable]="false" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Carga</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-wrap text-table-alignment">{{ row.fechaSubida }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="Vencimiento" [flexGrow]="4" [sortable]="false" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Vencimiento</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-wrap text-table-alignment">{{ row.fechaVenc }}</span>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="Acciones" [flexGrow]="3.3" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<a *ngIf="permissions.getPermission('20-20-16').asignado" class="primary edit mr-1 mrless" ngbTooltip="Descargar Certificado" id="mantenedor-certificados.component_Descargar_Certificado" (click)="CertificateDownloadRequest(row)">
													<div class="icon-circle bg-warning text-center align-middle pt-file-button">
														<fa-icon icon="file-code" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a *ngIf="permissions.getPermission('20-20-20').asignado && row.estadoId == 1 && !row.revocacionPendiente && row.origenCertificadoId != 4" class="primary edit mr-1 mrless" ngbTooltip="Solicitar Revocación" (click)="openRevokeModal(revokeCertificateModalRef, row)">
													<div class="icon-circle bg-danger text-center align-middle pt-info-button">
														<fa-icon icon="ban" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a class="primary edit mr-1 mrless" ngbTooltip="Activar Certificado" id="mantenedor-certificados.component_Activar_Certificado" (click)="activateCertificate(row)">
													<div class="icon-circle bg-success text-center align-middle pt-info-button">
														<fa-icon icon="check-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a
													*ngIf="permissions.getPermission('20-20-12').asignado" class="primary edit mr-1 mrless"
													ngbTooltip="Eliminar Certificado"
													[swal]="{
														title: 'Eliminar certificado',
														html: 'Si elimina este certificado, ya no podrá volver a descargarlo desde SimpleFactura.<br><br>Si el certificado tiene garantía, descárguelo y guárdelo primero en su equipo para no perderlo.<br><br>Si no tiene garantía, deberá comprar la reposición para poder descargarlo nuevamente.<br><br>Se recomienda guardar siempre una copia local antes de eliminar.<br><br>¿Desea continuar?',
														confirmButtonText: 'Sí, eliminar',
														cancelButtonText: 'Cancelar',
														showCancelButton: true,
														confirmButtonColor: '#F64E60'
													}"
													(confirm)="deleteCertificate(row)">
													<div class="icon-circle bg-danger text-center align-middle pt-info-button">
														<fa-icon icon="times-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="col-2 pl-0">Elementos por página</div>
												<div>
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="body">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-2 pl-1 pr-0 col-3 divisor-footer">
													<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableMobile.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
									<!-- fin seccion tabla mobile-->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #createCertificateModal let-d="dismiss" let-c="close">
	<div class="modal-lg" data-testid="certificate-upload-modal">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Ingreso de Certificados Digitales</div>
				<div class="modal-wizard-desc">Ingrese los datos y seleccione el archivo .pfx del certificado digital a ingresar</div>
			</div>
		</div>
		<div class="modal-body">
			<form [formGroup]="certificateForm" (ngSubmit)="addCertificate()" #certificateFormRef="ngForm">
				<div class="modal-body">
					<div class="mt-5 form-group position-relative mx-auto">
						<div class="row">
							<label for="" class="col-3 label-control">Rut Usuario</label>
							<div class="col-9">
								<input type="text" name="rutString" id="rutString" formControlName="rutString" class="form-control" maxlength="12" appFormatRut placeholder="Ingrese rut del usuario propietario del certificado digital"/>
								<div *ngIf="certificateFormRef.submitted && (certificateForm.get('rutString').invalid || certificateForm.get('rutString').dirty)" class="text-danger">
									<div *ngIf="certificateForm.get('rutString').hasError('VerificacionRutValidator')">Rut inválido</div>
									<div *ngIf="certificateForm.get('rutString').errors?.required">Campo requerido</div>
									<div *ngIf="certificateForm.get('rutString').errors?.maxLength">Mucho numero</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-5 form-group position-relative mx-auto">
						<div class="row">
							<label for="" class="col-3 label-control">Contraseña</label>
							<div class="col-9">
								<input
									type="password"
									class="form-control"
									id="password"
									formControlName="password"
									placeholder="Ingrese contraseña del certificado digital"
									[ngClass]="{
										'is-invalid': certificateFormRef.submitted && certificateForm.get('password').invalid
									}" />
								<div *ngIf="certificateFormRef.submitted && (certificateForm.get('password').invalid || certificateForm.get('password').dirty)" class="text-danger">
									<div *ngIf="certificateForm.get('password').errors?.required">Campo requerido</div>
								</div>
							</div>
						</div>
					</div>
					<div class="form-group position-relative mx-auto">
						<div class="row">
							<label for="" class="col-3 label-control">Empresa</label>
							<div class="col-9">
								<ng-select
									[items]="emisoresSource"
									[multiple]="false"
									placeholder="Seleccione Empresa"
									formControlName="emisor"
									[clearable]="false"
									bindLabel="razonSocial"
									[ngClass]="{
										'is-invalid': certificateFormRef.submitted && certificateForm.get('emisor').invalid
									}"></ng-select>
								<div *ngIf="certificateFormRef.submitted && (certificateForm.get('emisor').invalid || certificateForm.get('emisor').dirty || certificateForm.get('emisor').touched || certificateForm.get('emisor').value == null)" class="text-danger">
									<div *ngIf="certificateForm.get('emisor').errors?.required">Campo requerido</div>
								</div>
							</div>
						</div>
					</div>

					<div class="form-group position-relative mx-auto">
						<div class="row">
							<label for="" class="col-3 label-control">Certificado Digital</label>
							<div class="col-9">
								<ngx-dropzone #drop (change)="onFileChangeCER($event)" [multiple]="false">
									<ngx-dropzone-label class="px-5">
										<i class="flaticon-upload"></i>

										<p>Arrastra o selecciona el certificado digital.</p>

										<p>El formato del archivo debe ser .pfx</p>
									</ngx-dropzone-label>
									<ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemoveCertificaddoArray(f)">
										<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
									</ngx-dropzone-preview>
								</ngx-dropzone>
								<div *ngIf="certificateFormRef.submitted && (certificateForm.get('file').invalid || certificateForm.get('file').dirty || certificateForm.get('file').touched || certificateForm.get('file').value == null)" class="text-danger">
									<div *ngIf="certificateForm.get('file').errors?.required">Campo requerido</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item">
						<i class="la la-paper-plane-o d-lg-none"></i>
						<span class="d-none d-lg-block">Guardar</span>
					</button>
					<button type="button" class="btn btn-secondary ml-3" (click)="closeCreateCertificateModal()">
						<span class="d-none d-lg-block">Cerrar</span>
					</button>
				</div>
			</form>
		</div>
	</div>
</ng-template>

<ng-template #revokeCertificateModalRef let-d="dismiss" let-c="close">
	<div class="modal-lg">
	  <div class="modal-header">
		<div class="modal-wizard-label">
		  <div class="modal-wizard-title">Solicitud de Revocación</div>
		  <div class="modal-wizard-desc">
			La <b>revocación</b> deja sin vigencia tu Certificado de Firma Electrónica Simple.  
			Este proceso es <b>irreversible</b>.
		  </div>
		</div>
	  </div>
  
	  <form [formGroup]="revokeForm" (ngSubmit)="confirmRevoke()">
		<div class="modal-body">
  
		  <!-- INFO + requerimientos -->
		  <p>
			Adjunta tu cédula de identidad (ambos lados) y la
			<a href="javascript:void(0)"
				class="btn btn-link p-0"
				(click)="downloadCartaRevocacion()"
				[class.disabled]="loading">
				<fa-icon icon="file-pdf"></fa-icon>
				Carta de Solicitud de Revocación
			</a>			
			firmada. Puedes agregar hasta <b>3</b> documentos adicionales de respaldo.
		  </p>
  
		  <div class="alert alert-warning">
			Recuerda que el proceso de <b>Revocación</b> es irreversible.
		  </div>
  
		  <div class="row">
			<div class="col-md-6 form-group">
			  <label>Nombre Completo <span class="text-danger">*</span></label>
			  <input type="text" class="form-control" formControlName="nombre" />
			  <div *ngIf="revokeForm.get('nombre').touched && revokeForm.get('nombre').invalid"
				   class="text-danger">Campo requerido</div>
			</div>
  
			<div class="col-md-6 form-group">
			  <label>RUT <span class="text-danger">*</span></label>
			  <input type="text" class="form-control" formControlName="rut" maxlength="12" appVerificaRut appFormatRut placeholder="12.345.678-9" />
			  <div *ngIf="revokeForm.get('rut').touched && revokeForm.get('rut').invalid"
				   class="text-danger">
				  <div *ngIf="revokeForm.get('rut').errors?.required">Campo requerido</div>
				  <div *ngIf="revokeForm.get('rut').hasError('rutNoValido')">Rut inválido</div>
			  </div>
			</div>
  
			<div class="col-md-6 form-group">
			  <label>Correo Electrónico <span class="text-danger">*</span></label>
			  <input type="email" class="form-control" formControlName="correo" />
			  <div *ngIf="revokeForm.get('correo').touched && revokeForm.get('correo').invalid"
				   class="text-danger">Correo válido requerido</div>
			</div>
  
			<div class="col-md-6 form-group">
			  <label>Teléfono de Contacto</label>
			  <input type="text" class="form-control" formControlName="telefono" placeholder="+56 9 9123 4567" />
			</div>
  
			<div class="col-12 form-group">
			  <label>Comentarios</label>
			  <textarea rows="3" class="form-control" formControlName="comentarios"></textarea>
			</div>
  
			<!-- Dropzone para archivos -->
			<div class="col-12 form-group">
			  <label>Adjuntar archivos <span class="text-danger">*</span></label>
			  <ngx-dropzone (change)="onFilesAdded($event)" [multiple]="true">
				<ngx-dropzone-label>
				  <i class="flaticon-upload"></i>
				  <p>Arrastra o selecciona tus archivos (PDF / PNG / JPG). Máx 5 archivos.</p>
				</ngx-dropzone-label>
				<ngx-dropzone-preview
				  *ngFor="let f of revokeFiles"
				  [removable]="true"
				  (removed)="onRemoveFile(f)">
				  <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
				</ngx-dropzone-preview>
			  </ngx-dropzone>
			  <div *ngIf="filesError" class="text-danger">{{ filesError }}</div>
			</div>
  
			<!-- Checkbox confirmación irreversible -->
			<div class="col-12 form-group">
			  <div class="form-check">
				<input type="checkbox" id="chkConfirm"
					   class="form-check-input"
					   formControlName="confirmado" />
				<label class="form-check-label" for="chkConfirm">
				  Confirmo que deseo revocar mi certificado de forma irreversible.
				</label>
			  </div>
			  <div *ngIf="revokeForm.get('confirmado').touched && revokeForm.get('confirmado').invalid"
				   class="text-danger">Debe confirmar la revocación</div>
			</div>
  
		  </div><!-- /row -->
		</div><!-- /modal-body -->
  
		<div class="modal-footer">
		  <button type="submit"
				  class="btn btn-danger"
				  [disabled]="revokeForm.invalid || loading">
			<fa-icon icon="ban"></fa-icon> Enviar solicitud
		  </button>
		  <button type="button" class="btn btn-secondary" (click)="closeRevokeModal()">Cancelar</button>
		</div>
	  </form>
	</div>
  </ng-template>
  
<ng-template #reposicionCertModal let-d="dismiss" let-c="close">
  <div class="modal-header" style="background: #f8fafc; border-bottom: 1px solid #e0e7ef;">
    <h5 class="modal-title" style="color: #1b8bee;">Reposición de Certificado</h5>
    <button type="button" class="close" aria-label="Close" (click)="modalRefReposicion.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="modalReposicionData">
    <div class="alert border-0 mb-3" style="background: #fff8e1; border-left: 4px solid #f59e0b !important; border-radius: 6px;">
      <div class="d-flex align-items-start">
        <i class="fa fa-exclamation-triangle mr-2 mt-1" style="color: #d97706; font-size: 1.1rem; flex-shrink: 0;"></i>
        <div>
          <strong style="color: #92400e;">Importante sobre la reposición</strong>
          <ul class="mb-0 mt-1 pl-3" style="color: #374151;">
            <li>La reposición permite descargar nuevamente el <strong>mismo certificado digital</strong> comprado anteriormente.</li>
            <li><strong>No corresponde a un certificado nuevo</strong> y no permite cambiar ni restablecer la contraseña.</li>
            <li>Si olvidó la contraseña de su certificado digital, deberá <strong>comprar un nuevo certificado</strong>.</li>
            <li>El valor de reposición depende de la duración original del certificado.</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="mb-4 p-3" style="background: #e7f1fa; border-radius: 6px;">
      <div class="row">
        <div class="col-md-6"><b>Nombre certificado:</b> {{ modalReposicionData.nombre }}</div>
        <div class="col-md-6"><b>RUT certificado:</b>{{ modalReposicionData.rut }}</div>
      </div>
      <div class="row mt-1">
        <div class="col-md-6"><b>Correo:</b> {{ modalReposicionData.correo }}</div>
        <div class="col-md-6"><b>Fecha de vencimiento:</b> {{ modalReposicionData.fechaVenc | date:'dd/MM/yyyy' }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="mb-4">
          <label class="form-label" style="font-weight: 600; color: #333;"><b>Datos para emisión de la factura:</b></label>
          <select 
            class="form-control" 
            [(ngModel)]="empresaSeleccionada" 
            (ngModelChange)="onEmpresaSeleccionada($event)"
            style="border: 1px solid #d1d5db; border-radius: 6px;">
            <option [ngValue]="null">Seleccione una empresa</option>
            <option *ngFor="let empresa of empresasFacturacion" [ngValue]="empresa">
              {{ empresa.razonSocial }}
            </option>
          </select>
        </div>

        <div *ngIf="empresaSeleccionada" class="mb-4 p-3" style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 6px;">
          <div><b>RUT:</b> {{ empresaSeleccionada.rut + '-' + empresaSeleccionada.dv }}</div>
          <div class="mt-2"><b>Razón Social:</b> {{ empresaSeleccionada.razonSocial }}</div>
          <div class="mt-2"><b>Giro:</b> {{ empresaSeleccionada.giro }}</div>
          <div class="mt-2"><b>Comuna:</b> {{ empresaSeleccionada.comuna }}</div>
          <div class="mt-2"><b>Dirección:</b> {{ empresaSeleccionada.dirFact }}</div>
          <div class="mt-2"><b>Teléfono:</b> {{ empresaSeleccionada.telefono }}</div>
          <div class="mt-2"><b>Correo:</b> {{ empresaSeleccionada.correoFact }}</div>
        </div>
      </div>

      <div class="col-md-6">
        <label class="form-label" style="font-weight: 600; color: #333;"><b>Precios de reposición:</b></label>
        <p class="small">
          El certificado seleccionado <b>no cuenta con garantía</b>, por lo que la descarga tiene un costo adicional según el año de vigencia del certificado:
        </p>
        <div class="table-responsive">
          <table class="table table-bordered text-center" style="border-radius: 8px; overflow: hidden;">
            <thead>
              <tr style="background: #e7f1fa;">
                <th style="color: #1b8bee;">Año de vigencia certificado</th>
                <th style="color: #1b8bee;">Precio Reposición (+ IVA)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let anio of [1,2,3]">
                <td
                  [ngStyle]="anio === modalReposicionData.anios ? {'background': '#1b8bee', 'color': '#fff', 'fontWeight': 'bold'} : {}">
                  {{ anio }} año{{ anio > 1 ? 's' : '' }}
                </td>
                <td
                  [ngStyle]="anio === modalReposicionData.anios ? {'background': '#1b8bee', 'color': '#fff', 'fontWeight': 'bold'} : {}">
                  {{
                    (modalReposicionData.precios[anio].reposicion +
                      math.round(modalReposicionData.precios[anio].reposicion * 0.19))
                    | currency:'CLP':'symbol':'1.0-0':'es'
                  }}
                </td>
              </tr>
              <tr style="background: #f0f8ff;">
                <td colspan="1" class="font-weight-bold" style="color: #1b8bee;">
                  TOTAL A PAGAR:
                </td>
                <td class="font-weight-bold" style="font-size: 1.1rem; color: #1b8bee;">
                  {{
                    (modalReposicionData.precios[modalReposicionData.anios].reposicion +
                      math.round(modalReposicionData.precios[modalReposicionData.anios].reposicion * 0.19))
                    | currency:'CLP':'symbol':'1.0-0':'es'
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <p class="mt-3 mb-0 text-center">
      ¿Desea continuar con la reposición del certificado?
    </p>
  </div>
  <div class="modal-footer" style="background: #f8fafc; border-top: 1px solid #e0e7ef;">
    <button type="button" class="btn" style="background: #e4e7ed; color: #5a6371; border: none;" (click)="modalRefReposicion.close()">Cancelar</button>
    <button type="button" class="btn" style="background: #1b8bee; color: #fff; border: none;" [disabled]="!empresaSeleccionada" (click)="confirmarReposicion()">Comprar</button>
  </div>
</ng-template>
